export function dateFormatGet(date: Date): string {
  const result: string =
    (date.getDate() + "").padStart(2, "0") +
    "." +
    (date.getMonth() + 1 + "").padStart(2, "0") +
    "." +
    date.getFullYear();
  return result;
}
